import React from 'react';
import { Box, Grid } from '@mui/material';
import Perfil from './Perfil';
import Senha from './Senha';

const MeuPerfil = () => (
  <Box sx={{ p: 3 }}>
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 7 }}>
        <Perfil />
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <Senha />
      </Grid>
    </Grid>
  </Box>
);

export default MeuPerfil;
